import React, { useState, useEffect } from "react";
import Header from "../../components/Header/Header";
import Label from "../../components/Label/Label";
import Footer from "../../components/Footer/Footer";
import socialImg from "../../assests/img/social.svg";
import previous from "../../assests/img/previous.svg";
import next from "../../assests/img/next.svg";
import "./Portfolio.scss";
import { useDispatch, useSelector } from "react-redux";
import { getPortfolioAction } from "../../reduxThings/slices/DigipankSlices";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../config/seoConfig";
function Portfolio() {
  const [carousalStatus, setCarousalStatus] = useState(true);
  const dispatch = useDispatch();
  const handleClick = (data) => {
    setCarousalStatus(data);
  };
  useEffect(() => {
    dispatch(getPortfolioAction());
  }, []);
  const appData = useSelector(
    (e) => e?.DigipankSlice?.PortfolioState?.PortfolioStateData
  );
  console.log("data portfolio", appData)
  return appData?.title === "Portfolio" ? (
    <div className="portfolio_Page">
      <Seo {...PAGE_SEO.portfolio} />
      <Header handleClick={handleClick} />
      <div className="content_Section">
        <Label title={appData?.title}></Label>
        <Label title={appData?.desc}></Label>
      </div>
      <div className="image_Section">
        <img src={socialImg} className="social_Image" alt="Portfolio showcase" />
      </div>
      <div className="icon_Section">
        <img className="prev" src={previous} alt="Previous portfolio item" />
        <img src={next} alt="Next portfolio item" />
      </div>
      <Footer></Footer>
    </div>
  ) : (
    React.createElement("h1", {},
      <div className="loader-div">
        <div className="loader">
          <lottie-player
            autoplay
            loop
            src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
          ></lottie-player>
        </div>
      </div>
    )
  );
}

export default Portfolio;
